/* import __COLOCATED_TEMPLATE__ from './cancel-save-toolbar.hbs.js'; */
import Component from '@ember/component';
export default class CancelSaveToolbar extends Component {}